import * as Select from '@radix-ui/react-select';
import { ICONE_REDE } from './IconesRede';
import s from './SeletorRede.module.css';

/**
 * Combobox de rede social, com icone.
 *
 * Nao e um <select> nativo porque o navegador desenha a lista dele e
 * ignora qualquer marcacao dentro das <option> -- nao ha como colocar um
 * SVG ali. O Radix da o comportamento (teclado, foco, ARIA, rolagem,
 * posicionamento) e deixa a aparencia por nossa conta.
 */
export interface OpcaoRede {
  valor: string;
  rotulo: string;
  /** Ja escolhida em outra linha: o banco tem unique (user_id, rede). */
  indisponivel?: boolean;
}

export function SeletorRede({ valor, opcoes, aoMudar, id }: {
  valor: string;
  opcoes: OpcaoRede[];
  aoMudar: (v: string) => void;
  id?: string;
}) {
  const Atual = ICONE_REDE[valor];
  const rotuloAtual = opcoes.find((o) => o.valor === valor)?.rotulo ?? valor;

  return (
    <Select.Root value={valor} onValueChange={aoMudar}>
      <Select.Trigger className={s.gatilho} id={id} aria-label="Rede social">
        <span className={s.icone}>{Atual && <Atual />}</span>
        <Select.Value asChild>
          <span className={s.valor}>{rotuloAtual}</span>
        </Select.Value>
        <span className={s.seta}>{'▼'}</span>
      </Select.Trigger>

      <Select.Portal>
        <Select.Content className={s.conteudo} position="popper" sideOffset={5}>
          <Select.Viewport className={s.viewport}>
            {opcoes.map((o) => {
              const Icone = ICONE_REDE[o.valor];
              return (
                <Select.Item key={o.valor} value={o.valor}
                             disabled={o.indisponivel}
                             className={s.item}>
                  <span className={s.icone}>{Icone && <Icone />}</span>
                  <Select.ItemText>{o.rotulo}</Select.ItemText>
                </Select.Item>
              );
            })}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
}
